var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPassport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.958 58.85H14.9605C13.4755 58.85 12.293 57.6675 12.293 56.1825V15.0425C12.293 13.5575 13.4755 12.375 14.9605 12.375H50.9305C52.4155 12.375 53.598 13.5575 53.598 15.0425V56.1825C53.6255 57.6675 52.4155 58.85 50.958 58.85Z",
    stroke: "#3eb8aa",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9521 12.3734L47.4396 6.79095C48.3471 6.48845 49.7221 7.28595 50.2446 8.46845C50.7396 9.29345 50.7671 11.0534 50.7671 11.0534",
    stroke: "#3eb8aa",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9452 47.9587C39.7645 47.9587 45.2927 42.4305 45.2927 35.6112C45.2927 28.7918 39.7645 23.2637 32.9452 23.2637C26.1258 23.2637 20.5977 28.7918 20.5977 35.6112C20.5977 42.4305 26.1258 47.9587 32.9452 47.9587Z",
    stroke: "#3eb8aa",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9453 23.2637C32.9453 23.2637 44.0828 35.3362 32.9453 47.9587",
    stroke: "#3eb8aa",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9451 23.2637C32.9451 23.2637 21.8076 35.3362 32.9451 47.9587",
    stroke: "#3eb8aa",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5977 35.6113H45.3202",
    stroke: "#3eb8aa",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4844 27.6912C23.4844 27.6912 32.2019 33.7137 42.1294 27.3887",
    stroke: "#3eb8aa",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4844 43.6967C23.4844 43.6967 32.2019 37.6742 42.1294 43.9992",
    stroke: "#3eb8aa",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassport);
export default __webpack_public_path__ + "static/media/passport.ca68a08adb84f5e9811b6f0a391b8cdf.svg";
export { ForwardRef as ReactComponent };